import { render, staticRenderFns } from "./Sys.vue?vue&type=template&id=e4fdc132&scoped=true&lang=pug&"
import script from "./Sys.vue?vue&type=script&lang=ts&"
export * from "./Sys.vue?vue&type=script&lang=ts&"
import style0 from "./Sys.vue?vue&type=style&index=0&id=e4fdc132&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4fdc132",
  null
  
)

component.options.__file = "Sys.vue"
export default component.exports